<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				代理列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{total}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<div style="padding: 20px;display: flex;align-items: center;" class="search">
				<el-select v-model="form.software_id" filterable clearable placeholder="请选择所属软件"
					style="width: 150px;margin-right: 10px;" @change="search" size="small">
					<el-option v-for="(item,index) in software_list" :key="index"
						:label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-input clearable placeholder="代理人ID" v-model="form.agent_id" size="small"
					style="width: 250px;margin-right: 20px;" @clear="getData">
					<el-button slot="append" type="primary" icon="el-icon-search" @click="search"></el-button>
				</el-input>
				<el-input clearable placeholder="备注" v-model="form.mark" size="small"
					style="width: 250px;margin-right: 20px;" @clear="getData">
					<el-button slot="append" type="primary" icon="el-icon-search" @click="search"></el-button>
				</el-input>
				<!-- <el-button type="success" size="small" style="border-radius: 0;" @click="exportData">导出</el-button> -->
			</div>
			<div style="padding: 0px 20px 0px 20px;">
				<el-table :data="list" stripe
					style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;" size="small"
					@selection-change="handleSelectionChange"
					:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}" :row-style="{border_color:'rgb(75, 83, 87)'}"
					height="600" v-loading="loading">
					<el-table-column label="代理人备注" min-width="120" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.one}}
						</template>
					</el-table-column>
					<el-table-column label="代理人ID"  align="center">
						<template slot-scope="scope">
							{{scope.row.agent_id}}
						</template>
					</el-table-column>
					<el-table-column label="代理软件名称" width="300" align="center">
						<template slot-scope="scope">
							{{scope.row.software_name}}
						</template>
					</el-table-column>
					<el-table-column label="代理软件备注" width="300" align="center">
						<template slot-scope="scope">
							{{scope.row.software_one||'-'}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="300" align="center">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="toEdit(scope.row.id)">修改</el-button>
							<el-button type="danger" size="mini" @click="toDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="footer" style="margin-top: 15px;">
				<el-pagination layout="total, prev, pager, next" @current-change="toPage" :total="total"
					:page-sizes="[10,50,100,500,1000]" :current-page="form.page" :page-size="limit">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				cards: '',
				loading: false,
				days: 0,
				limit: 15,
				total: 0,
				form: {
					page:1,
					software_id:"",
					agent_id:"",
					mark:''
				},
				software_list: [],
				now_timestamp: 0,
				list: [],
				multipleSelection: []
			}
		},
		computed: {
			...mapState({
				user: state => state.user
			})
		},
		filters: {
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		created() {
			this.getData()
			this.getSoftwareList()
			this.now_timestamp = window.localStorage.getItem('timestamp_'+this.user.center_id)
		},
		methods: {
			search(){
				this.form.page = 1
				this.getData()
			},
			getSoftwareList() {
				this.$H.post('verify_center/v1_0_1.Software/list').then(res => {
					if(res.data){
						console.log(res.data.list)
						this.software_list = res.data.list;
					}
					
				});
			},
			
			confromCard() {
				this.dialogOptions = true
			},
			toEdit(agent_software_id) {
				this.$emit('toEdit', agent_software_id)

			},
			
			toDelete(item) {
				this.$confirm('删除后，该代理及子代理都会失去您软件的代理权限，确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('/verify_center/v1_0_1.Agent/Delete', {
						id:item.id
					}).then(res => {
						if(res.data){
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.search()
						}
					});

				}).catch(() => {

				});
			},
			
			search() {
				this.form.page = 1
				this.getData()
			},
			getData() {
				this.loading = true
				this.$H.post('/verify_center/v1_0_1.Agent/List', this.form).then(res => {
					this.loading = false
					if (res.data) {
						if (this.form.page === 1) {
							this.total = res.data.list.total
						}

						this.list = res.data.list.data

					}
				}).catch(err => {
					this.loading = false
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>